import {
  BackgroundColors,
  Gradients,
  NegativeColors,
  PositiveColors,
  PrimaryColors,
  SecondaryColors,
} from '@picsart/design-system/foundation/colors';

export enum OpacityOptions {
  Transparent = 0,
  Light = 0.25,
  Medium = 0.5,
  Heavy = 0.75,
  Solid = 1,
}

export enum ColorOptions {
  White = 'white',
  Black = 'black',
  Tint1 = 'tint1',
  Tint2 = 'tint2',
  Tint3 = 'tint3',
  Tint4 = 'tint4',
  Tint5 = 'tint5',
  Tint6 = 'tint6',
  Primary = 'primary',
  Secondary = 'Secondary',
  GradientPrimary = 'gradient-primary',
  GradientGold = 'gradient-gold',
  GradientDusk = 'gradient-dusk',
  GradientDesert = 'gradient-desert',
  GradientSunrise = 'gradient-sunrise',
  GradientSandyStorm = 'gradient-sandy-storm',
  GradientVenus = 'gradient-venus',
  GradientSahara = 'gradient-sahara',
  GradientAlien = 'gradient-alien',
  GradientMidnight = 'gradient-midnight',
  TestGradient = 'test-gradient',
}

export const mapColorOptionToCascadeColor = {
  [ColorOptions.White]: PositiveColors.base.default,
  [ColorOptions.Black]: NegativeColors.base.default,
  [ColorOptions.Tint1]: BackgroundColors.tint1,
  [ColorOptions.Tint2]: BackgroundColors.tint2,
  [ColorOptions.Tint3]: BackgroundColors.tint3,
  [ColorOptions.Tint4]: BackgroundColors.tint3,
  [ColorOptions.Tint5]: BackgroundColors.tint3,
  [ColorOptions.Tint6]: BackgroundColors.tint3,
  [ColorOptions.Primary]: PrimaryColors.base.default,
  [ColorOptions.Secondary]: SecondaryColors.base.default,
  [ColorOptions.GradientPrimary]: Gradients.primary,
  [ColorOptions.GradientGold]: Gradients.gold,
  [ColorOptions.GradientDusk]: Gradients.dusk,
  [ColorOptions.GradientDesert]: Gradients.desert,
  [ColorOptions.GradientSunrise]: Gradients.sunrise,
  [ColorOptions.GradientSandyStorm]: Gradients.sandyStorm,
  [ColorOptions.GradientVenus]: Gradients.venus,
  [ColorOptions.GradientSahara]: Gradients.sahara,
  [ColorOptions.GradientAlien]: Gradients.alien,
  [ColorOptions.GradientMidnight]: Gradients.midnight,
  // TODO remove when experiment done or replace with cascade
  [ColorOptions.TestGradient]:
    'linear-gradient(224.15deg, rgba(0, 0, 0, 1) 43.13%, #C209C1 180%, #72FFEA 136.08%, #C209C1 136.08%)',
};
